module.exports = __webpack_public_path__ + "img/innovations_small.9c2feae3.webp";